export default "__VITE_ASSET__BHNRzlR$__"